import { render, staticRenderFns } from "./WorkCenter.vue?vue&type=template&id=621e7cda&scoped=true"
import script from "./WorkCenter.vue?vue&type=script&lang=js"
export * from "./WorkCenter.vue?vue&type=script&lang=js"
import style0 from "./WorkCenter.vue?vue&type=style&index=0&id=621e7cda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621e7cda",
  null
  
)

export default component.exports